import { create } from "zustand";
import { api } from "@src/utils/axios-instance";
import toast from "react-hot-toast";
import { login, register } from "@src/services/requests/user";
import { Preferences } from "@src/types/global";
import { AxiosError } from "axios";
export type Role = "Anonymous" | "User" | "Admin";
export type UserStore = {
    authenticate: () => void;
    login: (data: { email: string; password: string }) => Promise<void>;
    logout: () => void;
    preferences: Preferences;
    setPreferences: (preferences: Preferences) => void;
    isLoggedIn: boolean;
    register_user: (data: {
        email: string;
        password: string;
        confirm_password: string;
        portfolio_link: string;
        terms_and_conditions: boolean;
        username?: string;
    }) => Promise<void | { password?: string[] }>;
    role: Role;
    setUser: (user: string) => void;
    setRole: (role: Role) => void;
    setToken: (token: string) => void;
    token: string | null;
    id: string;
    toggleIsLoggedIn: () => void;
    user: string;
};

export const useUserStore = create<UserStore>((set, get) => ({
    authenticate: async () => {
        try {
            const res = await api.get("/users/authenticate");
            if (res == undefined) {
                localStorage.clear();
                set({
                    token: null,
                    id: '',
                    role: "Anonymous",
                    isLoggedIn: false,
                });
                return;
            }
            set({
                token: localStorage.getItem("token"),
                id: localStorage.getItem("id") || "",
                isLoggedIn: true,
                role: res.data.data,
            });
        } catch (error: any) {
            if (error.response) {
                if (error.response.status == 401) {
                    get().logout();
                } else {
                    toast.error(
                        `Something's wrong: ${error.response.message} `,
                    );
                }
            }
        }
    },
    login: async (data) => {
        try {
            const res = await login(data)
            const { token, email, id } = res?.data || {};
            set(() => ({
                token: token,
                id: id,
                user: email,
                isLoggedIn: true,
            }));
            toast.success("Welcome !");
            localStorage.setItem("token", token);
            localStorage.setItem("email", email);
            localStorage.setItem("id", id);
        } catch (error) {
            console.log(error);
        }
    },
    logout: () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("id");
        localStorage.removeItem("characterList");
        set(() => ({ token: null, user: "", isLoggedIn: false }));
    },
    preferences: {
        measurement_unit: "metric",
        default_character_visibility: false,
        auto_grant_access_to_friends: false,
        color_scheme: "default",
    },
    setPreferences: (preferences) => {
        set(() => ({
            preferences: preferences,
        }));
    },
    register_user: async (data) => {
        try {
            const res = await register(data)
            //@ts-expect-errors
            if (res?.errors !== undefined) {
                //@ts-expect-errors
                return res.errors;
            }
            const { token, email, id } = res;
            toast.success("Welcome !");
            localStorage.setItem("token", token);
            localStorage.setItem("email", email);
            localStorage.setItem("id", id);
            set(() => ({
                token: token,
                user: email,
                id: id,
                isLoggedIn: true,
            }));
        } catch (error) {
            console.log(error);
        }
    },
    isLoggedIn: false,
    role: "Anonymous",
    token: null,
    id: "",
    toggleIsLoggedIn: () =>
        set(() => ({
            isLoggedIn: !get().isLoggedIn,
        })),
    user: "",
    setUser: (user) => {
        set(() => ({
            user: user,
        }));
    },
    setRole: (role) =>
        set(() => ({
            role: role,
        })),
    setToken: (token) =>
        set(() => ({
            token: token,
        })),
}));
